var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33366 0.333496H2.00033C1.26335 0.333496 0.666992 0.92985 0.666992 1.66683V12.3335C0.666992 13.0705 1.26335 13.6668 2.00033 13.6668H10.0003C10.7373 13.6668 11.3337 13.0705 11.3337 12.3335V4.3335L7.33366 0.333496ZM5.33366 12.3335H2.66699V11.0002H5.33366V12.3335ZM5.33366 10.3335H2.66699V9.00016H5.33366V10.3335ZM5.33366 8.3335H2.66699V7.00016H5.33366V8.3335ZM9.33366 12.3335H6.66699V11.0002H9.33366V12.3335ZM9.33366 10.3335H6.66699V9.00016H9.33366V10.3335ZM9.33366 8.3335H6.66699V7.00016H9.33366V8.3335ZM6.66699 5.00016V1.3335L10.3337 5.00016H6.66699Z",
    fill: "#7A7D80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.34b85ee3c2617451c8459c9f23b2b9ac.svg";
export { ForwardRef as ReactComponent };